export interface Drama {
  id: string;
  title: string;
  originalTitle: string;
  category: string;
  year: number;
  region: string;
  rating: number;
  episodes: number;
  status: string;
  description: string;
  longDescription: string;
  coverImage: string;
  posterImage: string;
  director: string;
  cast: string[];
  genres: string[];
  releaseDate: string;
  updateInfo: string;
  featured: boolean;
  trending: boolean;
  isNew: boolean;
  isHot: boolean;
}

export const dramas: Drama[] = [
  {
    id: 'drama-001',
    title: '长安十二时辰',
    originalTitle: 'The Longest Day in Chang\'an',
    category: 'guochanju',
    year: 2019,
    region: '中国大陆',
    rating: 8.8,
    episodes: 48,
    status: '已完结',
    description: '唐朝上元节前夕，长安城混入可疑人员，死囚张小敬临危受命，与李必携手在十二时辰内拯救长安。',
    longDescription: '故事发生在唐朝天宝三年，上元节前夕，长安城繁华热闹。然而，一场巨大的危机正在酝酿。突厥狼卫潜入长安，意图在上元节制造混乱。死囚张小敬被靖安司李必从死牢中提出，要求在十二个时辰内找出狼卫，阻止阴谋。张小敬凭借对长安城的熟悉和高超的武艺，与李必联手展开了惊心动魄的追捕行动。在这场与时间赛跑的战斗中，他们逐渐发现了一个更大的阴谋……',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20period%20drama%20poster%20with%20male%20protagonist%20in%20Tang%20Dynasty%20armor%20holding%20a%20sword%20in%20ancient%20Changan%20city%20at%20night%20with%20dramatic%20lighting%20and%20epic%20cinematic%20style%20dark%20moody%20tones&width=800&height=1120&seq=drama-cover-001&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20scene%20set%20in%20ancient%20Tang%20Dynasty%20Changan%20city%20at%20night%20with%20lanterns%20and%20bustling%20streets%20dramatic%20cinematic%20lighting%20warm%20golden%20and%20deep%20crimson%20tones%20film%20grain%20texture&width=1600&height=900&seq=drama-poster-001&orientation=landscape',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '芦芳生'],
    genres: ['古装', '悬疑', '动作'],
    releaseDate: '2019-06-27',
    updateInfo: '全48集已完结',
    featured: true,
    trending: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 'drama-002',
    title: '狂飙',
    originalTitle: 'The Knockout',
    category: 'guochanju',
    year: 2023,
    region: '中国大陆',
    rating: 9.1,
    episodes: 39,
    status: '已完结',
    description: '京海市一线刑警安欣在与黑恶势力的斗争中，与鱼贩高启强展开了长达二十年的黑白较量。',
    longDescription: '2000年，京海市一线刑警安欣在调查一起案件时，结识了在市场卖鱼的鱼贩高启强。高启强因长期受到市场管理员的欺凌，在一次冲突中失手杀人。安欣在办案过程中展现出了正义与善良，与高启强建立了特殊的联系。然而，高启强在权力的诱惑下逐渐堕落，成为了京海市最大的黑恶势力头目。二十年间，安欣始终没有放弃对高启强的追查，一场正义与邪恶的较量就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20two%20male%20actors%20facing%20each%20other%20one%20in%20police%20uniform%20one%20in%20dark%20suit%20intense%20standoff%20moody%20lighting%20with%20rain%20effects%20cinematic%20style&width=800&height=1120&seq=drama-cover-002&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Gritty%20Chinese%20crime%20drama%20scene%20in%20urban%20Chinese%20city%20at%20night%20with%20police%20car%20lights%20reflecting%20on%20wet%20streets%20dark%20moody%20atmosphere%20with%20neon%20accents%20cinematic%20film%20style&width=1600&height=900&seq=drama-poster-002&orientation=landscape',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    genres: ['犯罪', '剧情', '悬疑'],
    releaseDate: '2023-01-14',
    updateInfo: '全39集已完结',
    featured: true,
    trending: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 'drama-003',
    title: '庆余年',
    originalTitle: 'Joy of Life',
    category: 'guochanju',
    year: 2024,
    region: '中国大陆',
    rating: 8.9,
    episodes: 36,
    status: '第二季热播中',
    description: '范闲历经家族、江湖、庙堂的种种考验与锤炼，书写了一段光彩万丈的人生传奇。',
    longDescription: '范闲是庆国数十年风雨画卷的见证者，他容貌俊美，个性鲜明，深藏绝世神功。在剧中，范闲从海滨小城澹州初出茅庐，历经家族、江湖、庙堂的种种考验与锤炼。他重情重义，对于朋友和亲人，他可以不惜一切代价去保护。同时他又有着现代人的思维，在古代的权谋争斗中展现出了独特的智慧和勇气。第二季中，范闲将面临更大的挑战和更复杂的局面。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20period%20drama%20poster%20with%20handsome%20male%20lead%20in%20ancient%20Chinese%20robe%20holding%20a%20fan%20with%20mysterious%20expression%20in%20ancient%20palace%20setting%20with%20ethereal%20golden%20lighting&width=800&height=1120&seq=drama-cover-003&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Grand%20Chinese%20imperial%20palace%20scene%20with%20magnificent%20ancient%20Chinese%20architecture%20dramatic%20golden%20sunset%20light%20cascading%20through%20palace%20halls%20with%20silhouetted%20figures%20cinematic%20epic%20style&width=1600&height=900&seq=drama-poster-003&orientation=landscape',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    genres: ['古装', '奇幻', '剧情'],
    releaseDate: '2024-05-16',
    updateInfo: '更新至第28集',
    featured: true,
    trending: false,
    isNew: true,
    isHot: true,
  },
  {
    id: 'drama-004',
    title: '繁花',
    originalTitle: 'Blossoms Shanghai',
    category: 'guochanju',
    year: 2023,
    region: '中国大陆',
    rating: 9.3,
    episodes: 30,
    status: '已完结',
    description: '九十年代的上海，阿宝从平凡青年蜕变为商界后起之秀，在沪上弄潮儿女中留下一段传奇。',
    longDescription: '上世纪九十年代初，煌煌大时代，人人争上游。青年阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀。黄河路上，无人不晓。平凡阿宝蜕变为宝总，离不开高人爷叔与夜东京老板玲子、外贸大楼汪小姐的鼎力协助。随着神秘女子李李空降黄河路，一家时髦饭店平地而起，也搅动了整条街，也令宝总原本决胜千里的事业变得动荡惊心。与此同时，深圳股市的过江龙强总也随时给阿宝致命一击。阿宝唯有向前，以赤子之心翻越高山，奔赴繁花满眼。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%20with%20stylish%20male%20lead%20in%20vintage%20suit%20standing%20in%20front%20of%20neon%20lit%20Shanghai%20buildings%20at%20night%20nostalgic%20warm%20golden%20tones&width=800&height=1120&seq=drama-cover-004&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Shanghai%20street%20scene%20at%20night%20with%20vintage%20neon%20signs%20old%20Shanghai%20architecture%20and%20bustling%20street%20life%20warm%20golden%20glow%20and%20retro%20atmosphere%20cinematic%20widescreen&width=1600&height=900&seq=drama-poster-004&orientation=landscape',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    genres: ['剧情', '年代', '都市'],
    releaseDate: '2023-12-27',
    updateInfo: '全30集已完结',
    featured: false,
    trending: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 'drama-005',
    title: '使徒行者',
    originalTitle: 'Line Walker',
    category: 'gangju',
    year: 2014,
    region: '中国香港',
    rating: 8.7,
    episodes: 31,
    status: '已完结',
    description: '卧底探员在黑白两道间游走，既要完成任务又要保全自我，一场关于忠诚与背叛的较量。',
    longDescription: 'CIB总督察卓凯因警队好友康道行离奇死亡，开始寻找五名失联卧底的下落。在这个过程中，他结识了古惑仔薛家强和女卧底丁小嘉。三人从互不信任到携手合作，一步步揭开了警队内部的黑警网络。在这场正邪较量中，人性的贪婪、忠诚与背叛被展现得淋漓尽致。',
    coverImage: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20thriller%20TVB%20drama%20poster%20with%20undercover%20police%20officer%20in%20dark%20alley%20of%20Hong%20Kong%20with%20neon%20signs%20and%20rain%20soaked%20streets%20intense%20moody%20atmosphere%20cinematic%20style&width=800&height=1120&seq=drama-cover-005&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Iconic%20Hong%20Kong%20night%20cityscape%20with%20dense%20neon%20signs%20crowded%20streets%20and%20rain%20reflections%20on%20pavement%20warm%20neon%20glow%20against%20dark%20sky%20gritty%20urban%20atmosphere%20cinematic&width=1600&height=900&seq=drama-poster-005&orientation=landscape',
    director: '文伟鸿',
    cast: ['苗侨伟', '佘诗曼', '林峯', '陈敏之'],
    genres: ['警匪', '悬疑', '剧情'],
    releaseDate: '2014-08-25',
    updateInfo: '全31集已完结',
    featured: false,
    trending: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 'drama-006',
    title: '金枝欲孽',
    originalTitle: 'War and Beauty',
    category: 'gangju',
    year: 2004,
    region: '中国香港',
    rating: 9.0,
    episodes: 30,
    status: '已完结',
    description: '清朝嘉庆年间，后宫嫔妃们为争夺皇帝宠爱而展开的残酷宫斗大戏。',
    longDescription: '清朝嘉庆年间，后宫之中，皇后与如妃势成水火。新入宫的秀女玉莹、尔淳、安茜等人，各怀心思地进入这个是非之地。在权力的游戏中，她们或主动或被动地卷入了一场又一场的阴谋与算计。爱情、友情、亲情在这座深宫之中经受着最严酷的考验。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20palace%20drama%20poster%20with%20beautiful%20women%20in%20elaborate%20Qing%20Dynasty%20imperial%20costumes%20and%20headdresses%20in%20luxurious%20palace%20interior%20with%20intricate%20details%20dramatic%20lighting%20warm%20golden%20hues&width=800&height=1120&seq=drama-cover-006&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Luxurious%20ancient%20Chinese%20imperial%20palace%20interior%20with%20ornate%20carved%20wooden%20decor%20red%20lanterns%20and%20golden%20accents%20dramatic%20shadows%20and%20soft%20candle%20light%20warm%20regal%20atmosphere%20cinematic&width=1600&height=900&seq=drama-poster-006&orientation=landscape',
    director: '戚其义',
    cast: ['邓萃雯', '张可颐', '佘诗曼', '黎姿'],
    genres: ['古装', '宫斗', '剧情'],
    releaseDate: '2004-08-23',
    updateInfo: '全30集已完结',
    featured: false,
    trending: false,
    isNew: false,
    isHot: false,
  },
  {
    id: 'drama-007',
    title: '权力的游戏',
    originalTitle: 'Game of Thrones',
    category: 'meiju',
    year: 2011,
    region: '美国',
    rating: 9.3,
    episodes: 73,
    status: '已完结',
    description: '维斯特洛大陆上，几大家族为争夺铁王座展开了一场史诗级的权力斗争。',
    longDescription: '在维斯特洛大陆上，七大王国的贵族家族为争夺铁王座而展开了一场史诗级的权力斗争。史塔克家族、兰尼斯特家族、坦格利安家族——每个家族都有着自己的野心和秘密。在北方，一个古老的邪恶力量正在苏醒。在东方，龙之母丹妮莉丝逐渐成长。战争、背叛、爱情、牺牲，这场权力的游戏中没有永远的赢家。',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20drama%20poster%20with%20figures%20sitting%20on%20iron%20throne%20made%20of%20swords%20in%20dark%20medieval%20castle%20with%20dragons%20silhouetted%20against%20stormy%20sky%20dark%20dramatic%20fantasy%20art%20style&width=800&height=1120&seq=drama-cover-007&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20medieval%20landscape%20with%20snow%20covered%20mountains%20ancient%20castle%20on%20cliff%20and%20dragons%20flying%20in%20stormy%20dark%20sky%20dramatic%20and%20cinematic%20fantasy%20art%20style%20with%20cool%20blue%20and%20dark%20tones&width=1600&height=900&seq=drama-poster-007&orientation=landscape',
    director: '大卫·贝尼奥夫',
    cast: ['艾米莉亚·克拉克', '基特·哈灵顿', '彼特·丁拉基', '琳娜·海蒂'],
    genres: ['奇幻', '史诗', '剧情'],
    releaseDate: '2011-04-17',
    updateInfo: '全8季已完结',
    featured: true,
    trending: false,
    isNew: false,
    isHot: false,
  },
  {
    id: 'drama-008',
    title: '怪奇物语',
    originalTitle: 'Stranger Things',
    category: 'meiju',
    year: 2016,
    region: '美国',
    rating: 9.0,
    episodes: 34,
    status: '第五季即将上线',
    description: '印第安纳州霍金斯小镇上，一名男孩神秘失踪，朋友们在寻找过程中发现了超自然力量的秘密。',
    longDescription: '1983年，印第安纳州霍金斯小镇上，12岁的男孩威尔·拜尔斯神秘失踪。他的母亲乔伊斯、警长霍珀以及他的朋友们开始了一场惊心动魄的寻找之旅。在这个过程中，他们遇到了一个拥有超能力的女孩十一，并逐渐发现小镇地下隐藏着一个可怕的神秘实验室和一个被称为"逆世界"的平行维度。',
    coverImage: 'https://readdy.ai/api/search-image?query=Retro%201980s%20sci-fi%20horror%20drama%20poster%20with%20group%20of%20kids%20on%20bicycles%20silhouetted%20against%20mysterious%20red%20glowing%20sky%20with%20nostalgic%20vintage%20aesthetic%20dark%20and%20eerie%20atmosphere&width=800&height=1120&seq=drama-cover-008&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Small%20American%20town%20at%20night%20in%201980s%20with%20neon%20signs%20and%20mysterious%20red%20glow%20in%20sky%20vintage%20cars%20and%20bicycles%20nostalgic%20retro%20atmosphere%20with%20eerie%20undertones%20cinematic%20style&width=1600&height=900&seq=drama-poster-008&orientation=landscape',
    director: '达菲兄弟',
    cast: ['米莉·波比·布朗', '芬恩·伍法德', '薇诺娜·瑞德', '大卫·哈伯'],
    genres: ['科幻', '恐怖', '悬疑'],
    releaseDate: '2016-07-15',
    updateInfo: '第四季已完结',
    featured: false,
    trending: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 'drama-009',
    title: '黑暗荣耀',
    originalTitle: 'The Glory',
    category: 'hanju',
    year: 2022,
    region: '韩国',
    rating: 9.2,
    episodes: 16,
    status: '已完结',
    description: '曾在高中时期遭受校园暴力的女子，精心策划了一场向加害者和旁观者复仇的计划。',
    longDescription: '文东恩在高中时期遭受了残酷的校园暴力，被富家女朴妍珍为首的施暴者用烫发棒灼伤全身。多年后，她成为朴妍珍女儿的班主任，开始了一场精心策划的复仇。在这个过程中，她遇到了同样怀有伤痛的医生周汝正。两人在复仇与救赎的路上互相扶持，揭开了人性的黑暗面。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20thriller%20drama%20poster%20with%20mysterious%20woman%20in%20dark%20elegant%20clothing%20standing%20in%20shadows%20with%20intense%20gaze%20cold%20dramatic%20lighting%20dark%20and%20sophisticated%20mood&width=800&height=1120&seq=drama-cover-009&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Luxurious%20modern%20Korean%20mansion%20interior%20at%20night%20with%20dramatic%20shadows%20and%20cold%20elegant%20atmosphere%20minimalist%20Korean%20design%20with%20dark%20and%20moody%20cinematic%20lighting%20sophisticated%20and%20eerie&width=1600&height=900&seq=drama-poster-009&orientation=landscape',
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '朴成勋'],
    genres: ['复仇', '剧情', '悬疑'],
    releaseDate: '2022-12-30',
    updateInfo: '全16集已完结',
    featured: true,
    trending: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 'drama-010',
    title: '鱿鱼游戏',
    originalTitle: 'Squid Game',
    category: 'hanju',
    year: 2021,
    region: '韩国',
    rating: 8.5,
    episodes: 9,
    status: '第二季即将上线',
    description: '456名负债累累的人被邀请参加一场儿童游戏的生死竞赛，赢家将获得456亿韩元奖金。',
    longDescription: '一群生活失意、负债累累的人收到了一个神秘的邀请，参加一场奖金高达456亿韩元的游戏。但他们很快发现，这场游戏远比想象中残酷——失败者将付出生命的代价。成奇勋是一名离婚的司机，背负着巨额赌债。为了给女儿更好的生活，他参加了这场致命游戏，与其他参赛者一起经历了惊心动魄的考验。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20survival%20thriller%20drama%20poster%20with%20figures%20in%20green%20tracksuits%20standing%20in%20bright%20colorful%20staircase%20room%20with%20geometric%20shapes%20and%20pink%20guards%20striking%20visual%20contrast%20bold%20design&width=800&height=1120&seq=drama-cover-010&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Surreal%20colorful%20playground%20with%20giant%20doll%20and%20bright%20pastel%20walls%20in%20Korean%20children%20game%20setting%20with%20eerie%20contrast%20between%20innocent%20colors%20and%20dark%20undertones%20cinematic%20widescreen&width=1600&height=900&seq=drama-poster-010&orientation=landscape',
    director: '黄东赫',
    cast: ['李政宰', '朴海秀', '郑好娟', '魏嘏隽'],
    genres: ['悬疑', '剧情', '惊悚'],
    releaseDate: '2021-09-17',
    updateInfo: '第一季已完结',
    featured: false,
    trending: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 'drama-011',
    title: '非自然死亡',
    originalTitle: 'Unnatural',
    category: 'riju',
    year: 2018,
    region: '日本',
    rating: 9.4,
    episodes: 10,
    status: '已完结',
    description: '法医三澄美琴在非自然死亡原因研究所工作，通过解剖探寻每个死者背后的真相。',
    longDescription: '在日本，八成以上的非自然死亡都会被草草火化处理。法医三澄美琴在UDI研究所工作，她坚信解剖能够揭示死者最后的声音。与同事们一起，他们面对一个又一个看似普通的死亡案件，却在抽丝剥茧中发现了令人震惊的真相。每一个死者都有自己的故事，而美琴的责任就是让这些故事不被埋没。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20medical%20forensic%20mystery%20drama%20poster%20with%20female%20doctor%20in%20white%20lab%20coat%20in%20modern%20laboratory%20setting%20with%20clean%20minimalist%20aesthetic%20moody%20cool%20lighting%20professional%20atmosphere&width=800&height=1120&seq=drama-cover-011&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20forensic%20laboratory%20interior%20with%20clean%20white%20surfaces%20medical%20equipment%20and%20soft%20cool%20fluorescent%20lighting%20minimalist%20Japanese%20design%20aesthetic%20professional%20and%20sleek%20atmosphere&width=1600&height=900&seq=drama-poster-011&orientation=landscape',
    director: '冢原亚由子',
    cast: ['石原里美', '井浦新', '洼田正孝', '市川实日子'],
    genres: ['法医', '悬疑', '剧情'],
    releaseDate: '2018-01-12',
    updateInfo: '全10集已完结',
    featured: false,
    trending: true,
    isNew: false,
    isHot: false,
  },
  {
    id: 'drama-012',
    title: '想见你',
    originalTitle: 'Someday or One Day',
    category: 'taiju',
    year: 2019,
    region: '中国台湾',
    rating: 9.2,
    episodes: 13,
    status: '已完结',
    description: '黄雨萱通过一台随身听穿越到1998年，以陈韵如的身份遇到了与已故男友长得一模一样的李子维。',
    longDescription: '2019年，黄雨萱的男友王诠胜在两年前因空难去世。她始终无法走出伤痛，直到收到一台神秘的随身听。在听伍佰的《Last Dance》时，她穿越到了1998年，成为了一名叫做陈韵如的高中生。在那里，她遇到了和王诠胜长得一模一样的李子维。命运的齿轮开始转动，一场跨越时空的爱情故事就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Taiwanese%20romance%20time%20travel%20drama%20poster%20with%20young%20couple%20in%20high%20school%20uniforms%20holding%20hands%20under%20cassette%20tape%20motif%20nostalgic%20warm%20sunlight%20through%20classroom%20windows%20soft%20dreamy%20aesthetic&width=800&height=1120&seq=drama-cover-012&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Nostalgic%20Taiwanese%20high%20school%20classroom%20scene%20with%20soft%20golden%20sunlight%20streaming%20through%20windows%20dust%20motes%20in%20air%20and%20vintage%20cassette%20player%20on%20desk%20warm%20nostalgic%20atmosphere%20dreamy%20cinematic&width=1600&height=900&seq=drama-poster-012&orientation=landscape',
    director: '黄天仁',
    cast: ['柯佳嬿', '许光汉', '施柏宇', '颜毓麟'],
    genres: ['爱情', '奇幻', '悬疑'],
    releaseDate: '2019-11-17',
    updateInfo: '全13集已完结',
    featured: false,
    trending: true,
    isNew: false,
    isHot: false,
  },
  {
    id: 'drama-013',
    title: '风骚律师',
    originalTitle: 'Better Call Saul',
    category: 'oumeiju',
    year: 2015,
    region: '美国',
    rating: 9.7,
    episodes: 63,
    status: '已完结',
    description: '吉米·麦吉尔从一个挣扎的小律师蜕变为游走在法律边缘的"风骚律师"索尔·古德曼的传奇故事。',
    longDescription: '在成为人称"风骚律师"的索尔·古德曼之前，他还叫吉米·麦吉尔——一个努力挣扎的底层律师，在哥哥的光环下艰难求生。从一个小小的公共辩护律师开始，吉米经历了无数的挫折和不公。这些经历一点点塑造了他的价值观，最终让他成为了那个游走在法律边缘的索尔·古德曼。',
    coverImage: 'https://readdy.ai/api/search-image?query=American%20legal%20crime%20drama%20poster%20with%20middle%20aged%20lawyer%20in%20colorful%20suit%20standing%20in%20desert%20landscape%20of%20New%20Mexico%20with%20vintage%20car%20quirk%20and%20dramatic%20warm%20desert%20lighting&width=800&height=1120&seq=drama-cover-013&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Vast%20New%20Mexico%20desert%20landscape%20at%20golden%20sunset%20with%20lone%20vintage%20car%20on%20endless%20highway%20dramatic%20warm%20desert%20colors%20and%20crisp%20cinematography%20widescreen%20epic%20scale&width=1600&height=900&seq=drama-poster-013&orientation=landscape',
    director: '文斯·吉里根',
    cast: ['鲍勃·奥登科克', '乔纳森·班克斯', '蕾亚·塞洪', '帕特里克·法比安'],
    genres: ['犯罪', '剧情', '律政'],
    releaseDate: '2015-02-08',
    updateInfo: '全六季已完结',
    featured: false,
    trending: false,
    isNew: false,
    isHot: false,
  },
  {
    id: 'drama-014',
    title: '鬼灭之刃',
    originalTitle: 'Demon Slayer',
    category: 'donghuaju',
    year: 2019,
    region: '日本',
    rating: 9.3,
    episodes: 55,
    status: '连载中',
    description: '少年灶门炭治郎在家人被鬼杀害后，为了将变成鬼的妹妹变回人类，踏上了成为鬼杀队成员的旅程。',
    longDescription: '大正时代，少年灶门炭治郎一家被鬼杀害，唯一幸存下来的妹妹祢豆子却变成了鬼。为了让妹妹变回人类并讨伐杀害家人的鬼，炭治郎决心沿着"鬼杀队"的道路前进。在修行和战斗中，他不仅掌握了水之呼吸，还觉醒了火之神乐——日之呼吸的奥秘。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20style%20poster%20with%20young%20swordsman%20in%20traditional%20Japanese%20kimono%20holding%20katana%20with%20water%20dragon%20effect%20surrounding%20him%20vibrant%20anime%20art%20style%20dynamic%20composition&width=800&height=1120&seq=drama-cover-014&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20mountain%20landscape%20with%20traditional%20Japanese%20village%20at%20dusk%20with%20crimson%20and%20indigo%20sky%20snow%20capped%20mountains%20in%20distance%20and%20floating%20cherry%20blossom%20petals%20dramatic%20anime%20aesthetic&width=1600&height=900&seq=drama-poster-014&orientation=landscape',
    director: '外崎春雄',
    cast: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    genres: ['动画', '热血', '奇幻'],
    releaseDate: '2019-04-06',
    updateInfo: '更新至锻刀村篇',
    featured: false,
    trending: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 'drama-015',
    title: '琅琊榜',
    originalTitle: 'Nirvana in Fire',
    category: 'guochanju',
    year: 2015,
    region: '中国大陆',
    rating: 9.5,
    episodes: 54,
    status: '已完结',
    description: '麒麟才子梅长苏以病弱之躯，搅动朝堂风云，为十二年前的赤焰军冤案平反昭雪。',
    longDescription: '十二年前，大梁赤焰军被诬谋反，七万将士葬身梅岭。少帅林殊侥幸存活，历经削皮挫骨之痛，化身为江左盟宗主梅长苏。十二年后，他以"麒麟才子"之名回到金陵，表面上辅佐靖王夺嫡，实则暗中布局，一步步揭开当年的阴谋。在这场权谋与复仇的大戏中，梅长苏以病弱之躯搅动朝堂风云，最终为赤焰军洗清冤屈。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20political%20drama%20poster%20with%20elegant%20scholar%20in%20white%20robe%20holding%20fan%20standing%20in%20front%20of%20ancient%20Chinese%20palace%20with%20falling%20snow%20dramatic%20and%20poetic%20atmosphere%20cool%20tones&width=800&height=1120&seq=drama-cover-015&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20courtyard%20in%20winter%20with%20falling%20snow%20traditional%20Chinese%20architecture%20with%20curved%20roofs%20and%20red%20lanterns%20silent%20and%20poetic%20atmosphere%20misty%20mountains%20in%20background%20cinematic&width=1600&height=900&seq=drama-poster-015&orientation=landscape',
    director: '孔笙',
    cast: ['胡歌', '刘涛', '王凯', '陈龙'],
    genres: ['古装', '权谋', '剧情'],
    releaseDate: '2015-09-19',
    updateInfo: '全54集已完结',
    featured: true,
    trending: true,
    isNew: false,
    isHot: true,
  },
  {
    id: 'drama-016',
    title: '无证之罪',
    originalTitle: 'Burning Ice',
    category: 'guochanju',
    year: 2017,
    region: '中国大陆',
    rating: 8.9,
    episodes: 12,
    status: '已完结',
    description: '东北小城里，一个雪人杀人案牵出了错综复杂的人性罪恶，警察严良面对前所未有的挑战。',
    longDescription: '在东北的一座小城哈松，一个神秘的雪人杀人案震惊全城。凶手在现场留下"请来抓我"的挑衅字条，并制造了一系列连环谋杀。刑警严良被派来调查此案，却发现自己面对的不仅是一个高智商的连环杀手，还有一个牵扯到各方势力的巨大阴谋。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20mystery%20thriller%20poster%20set%20in%20snowy%20northeast%20China%20with%20detective%20in%20heavy%20coat%20standing%20in%20snow%20covered%20alley%20dark%20and%20cold%20atmosphere%20with%20hint%20of%20blood%20red%20accents&width=800&height=1120&seq=drama-cover-016&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Bleak%20northeast%20Chinese%20small%20town%20in%20deep%20winter%20covered%20in%20thick%20snow%20with%20dim%20street%20lamps%20and%20lonely%20figures%20walking%20through%20dark%20alleys%20cold%20eerie%20atmosphere%20cinematic%20noir%20style&width=1600&height=900&seq=drama-poster-016&orientation=landscape',
    director: '吕行',
    cast: ['秦昊', '邓家佳', '姚橹', '代旭'],
    genres: ['犯罪', '悬疑', '剧情'],
    releaseDate: '2017-09-06',
    updateInfo: '全12集已完结',
    featured: false,
    trending: false,
    isNew: false,
    isHot: false,
  },
];

export const getDramaById = (id: string): Drama | undefined => {
  return dramas.find((d) => d.id === id);
};

export const getDramasByCategory = (categorySlug: string): Drama[] => {
  return dramas.filter((d) => d.category === categorySlug);
};

export const getFeaturedDramas = (): Drama[] => {
  return dramas.filter((d) => d.featured);
};

export const getTrendingDramas = (): Drama[] => {
  return dramas.filter((d) => d.trending);
};

export const getHotDramas = (): Drama[] => {
  return dramas.filter((d) => d.isHot);
};

export const getNewDramas = (): Drama[] => {
  return dramas.filter((d) => d.isNew);
};